const tinyMceApiKey = "6wcoybkstvpk8x6n3t339lkzyoojl3iqk9f1w43lbi361z5r"

export default {
  tinyMceApiKey,
}
